import { useTranslation } from 'helpers/hooks/useTranslation'
import React, { FC } from 'react'
import styled from 'styled-components'
import {
  backgroundColor,
  complementaryColor,
  logoColor,
} from 'uiComponents/constants/colors'
import { fsXS } from 'uiComponents/constants/typography'

const Container = styled.div`
  height: 248px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    to bottom,
    ${backgroundColor},
    ${complementaryColor}
  );
  margin: 0 0 30px;
  border-bottom: 1px solid #e6e6e7;
`

const Subline = styled.div`
  font-size: ${fsXS};
  color: ${logoColor};
  line-height: 1.5;
  margin: 10px 0 40px 10px;
`

const EmptyResult: FC = () => {
  const [t] = useTranslation()
  return (
    <>
      <Container>
        <div>
          <Subline data-testid="EmptyResultSubline">
            {t('Leider nichts gefunden ...')}
          </Subline>
        </div>
      </Container>
    </>
  )
}

export default EmptyResult
